var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',_vm._b({attrs:{"number-to-display":2,"hide-default-bg-image":"","heading":((_vm.report.contacts.cover.planName) + " - Fund overview")}},'page',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }